module.exports = __webpack_public_path__ + "static/media/compliance_documentation.a460632f.png";